import { T } from "components/util/t";
import { Redirect, useLocation, useRouteMatch } from "react-router-dom";
import { RefObject, useRef } from "react";
import { ActionNotificationSticky } from "components/notifications/ActionNotificationSticky";
import { isHeatSupported } from "./isHeatSupported";
import { useFeatureFlags } from "components/providers/featureFlags/useFeatureFlags";
import { DetachableChannelProvider } from "components/providers/Realtime/RealtimeProvider";
import { useGetCurrentHeatsConfig } from "./useGetCurrentHeatsConfig";

export const NewScoringInterfaceNotification = () => {
    const isOldJudgePage = useRouteMatch("/events/:id/scoring") as {
        params: { id: string };
    } | null;
    const hasOptedOut = useRef(false);
    const eventId = isOldJudgePage?.params.id;

    if (!eventId) return null;

    const eventChannel = `event:${eventId}`;

    return (
        <DetachableChannelProvider channelName={eventChannel}>
            <Notification eventId={eventId} hasOptedOut={hasOptedOut} />
        </DetachableChannelProvider>
    );
};

type NotificationProps = {
    eventId: string;
    hasOptedOut: RefObject<boolean>;
};

const Notification = ({ eventId, hasOptedOut }: NotificationProps) => {
    const { state }: { state: { optout: boolean } } = useLocation();
    if (state?.optout) hasOptedOut.current = true;

    const { data } = useGetCurrentHeatsConfig(eventId);

    const isNewScoringInterfaceNotificationEnabled = useFeatureFlags(
        "New scoring UI notification",
    );
    if (!isNewScoringInterfaceNotificationEnabled) return null;

    if (
        !isHeatSupported(
            data?.event?.currentHeats
                ?.filter((currentHeat) => currentHeat !== null)
                .map((currentHeat) => currentHeat.config),
        )
    )
        return null;

    return hasOptedOut.current ? (
        <ActionNotificationSticky
            text={<T eventId={eventId}>new_scoring_interface_notification</T>}
            size="medium"
        />
    ) : (
        <Redirect to={`/events/${eventId}/judge`} />
    );
};
